import { RepositoryFirebase } from "../common/repository.firebase";
import { ProductImageQRCode } from "./product-image-qrcode.entity";

export class ProductImageQRCodeRepository extends RepositoryFirebase<ProductImageQRCode> {
    protected collection = 'product-image-qrcodes';
    protected entity = ProductImageQRCode;
}

export const productImageQRCodeRepository = new ProductImageQRCodeRepository();